import { defineComponent } from 'vue'

export default defineComponent({
    data() {
        return {
            show1: false
        }
    }
})
